import { IAsset } from './IAsset';
import { IAssetProvider } from './IAssetProvider';

export { IAsset, IAssetProvider };
